import clsx from "clsx";
import CreatePage from "./CreatePage/CreatePage";
import FailPage from "./FailPage/FailPage";
import IndexPage from "./IndexPage/MainindexPage";
import LoadingPage from "./LoadingPage/MainLoadingPage";
import React from "react";
import styles from "./Content.module.scss";
import SuccessPage from "./SuccessPage/ResultSuccessPage";
import useEffectStore from "@/stores/effectStore";
import GuidTip from "@/components/guid-tip/GuidTip";
import { withPublicPath } from "@/utils";
import MoreButton from "@/components/more-button";
import { PageType } from "@/constants";
const SINGLE_GUID_TIP_PROPS = {
  imgSrc: withPublicPath("videos/guid.mp4"),
  title: "guid_title",
  step1: "guid_step1",
  step2: "guid_step2",
  step3: "guid_step3",
  step1Desc: "single_guid_step1_desc",
  step2Desc: "single_guid_step2_desc",
  step3Desc: "single_guid_step3_desc",
  tip: "single_guid_tips",
  type:"video" 
};
interface RightResultProps {
  className?: string;
}

export default function EffectRightResult(props: RightResultProps) {
  const { className } = props;
  const guidShow = useEffectStore((state) => state.guidShow);
  const setGuidShow = useEffectStore((state) => state.setGuidTipShow);
  const pageType = useEffectStore((state) => state.pageType);
  return (
    <div
      className={clsx(styles.content, className)}
      style={{ position: "relative" }}
    >
      {pageType === PageType.Ready && <IndexPage />}
      {pageType === PageType.Create && <CreatePage />}
      {pageType === PageType.Generating && <LoadingPage />}
      {pageType === PageType.Result && <SuccessPage />}
      {pageType === PageType.Failed && <FailPage />}
      {/* <LoadingPage/> */}
      {guidShow && (
        <GuidTip
          {...SINGLE_GUID_TIP_PROPS}
          onClose={() => {
            setGuidShow(false);
          }}
        />
      )}
      <div className={styles.more_mene}>
        <MoreButton />
      </div>
    </div>
  );
}
